import isArrayLike from "./component-library390.mjs";
import isObjectLike from "./component-library270.mjs";
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
export {
  isArrayLikeObject as default
};
